import { clsx } from 'clsx';
import { OTPInput, OTPInputContext } from 'input-otp';
import { Minus } from 'lucide-react';
import * as React from 'react';

import styles from './input-otp.module.scss';

const InputOTP = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<typeof OTPInput>
>(({ className, containerClassName, ...props }, ref) => (
  <OTPInput
    ref={ref}
    className={clsx(styles.disabled, className)}
    containerClassName={clsx(styles.inputOTP, containerClassName)}
    data-slot='input-otp'
    {...props}
  />
));

const InputOTPGroup = ({
  className,
  ...props
}: React.ComponentProps<'div'>) => (
  <div
    data-slot='input-otp-group'
    className={clsx(styles.inputOTPGroup, className)}
    {...props}
  />
);

const InputOTPSlot = ({
  index,
  className,
  ...props
}: React.ComponentProps<'div'> & {
  index: number;
}) => {
  const inputOTPContext = React.useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext?.slots[index] ?? {};

  return (
    <div
      data-slot='input-otp-slot'
      data-active={isActive}
      className={clsx(styles.inputOTPSlot, className)}
      {...props}
    >
      {char}
      {hasFakeCaret && <div className={styles.caret} />}
    </div>
  );
};

const InputOTPSeparator = ({ ...props }: React.ComponentProps<'div'>) => (
  <div
    data-slot='input-otp-separator'
    role='separator'
    className={styles.inputOTPSeparator}
    {...props}
  >
    <Minus />
  </div>
);

export { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot };
